'use strict';
module.exports = function validEmail(email) {
	if (!email || !email.length || email.length <= 2) {
		return false;
	}
	if (/["[,\s<>]/.test(email)) {
		return false;
	}
	if (email.indexOf('..') > -1) {
		return false;
	}
	const components = email.split('@');
	if (!components[0] || !components[1]) {
		return false;
	}
	if (components.length !== 2) {
		return false;
	}
	if (/\.$/.test(components[0])) {
		return false;
	}
	if (/^\./.test(components[0])) {
		return false;
	}

	if (/[.,\s-]$/.test(components[1])) {
		return false;
	}
	if (/^[.,\s-]/.test(components[1])) {
		return false;
	}
	if (components[1].indexOf('.') < 0) {
		return false;
	}
	if (/\d+\.\d+.\d+.\d+/.test(components[1])) {
		return false;
	}

	return true;
};
